import { useEffect, useState } from "react";
import axios from "axios";
import "./orderCard.css";
import { useSelector } from "react-redux";

function OrderCard({ id, status, date, total, items, buyerId }) {
  const [buyer, setBuyer] = useState([]);
  const [productsData, setProductsData] = useState([]);

  const tokenBearer = useSelector((state) => state.token);

  const getBuyer = async () => {
    const authAxios = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}/private/buyer`,
      headers: {
        Authorization: `Bearer ${tokenBearer.token}`,
        ContentType: `application/json`,
      },
    });
    try {
      const res = await authAxios.get(
        `${process.env.REACT_APP_API_URL}/private/buyer`
      );
      setBuyer(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getProductsData = async () => {
    try {
      const productsData = await axios
        .get(
          `${process.env.REACT_APP_API_URL}/products?items=${items
            .map((item) => item.productId) // consigo solo los ids del array de items
            .join("-")}`
        )
        .then((res) => res.data);

      setProductsData(productsData);
      // console.log(productsData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getBuyer();
    getProductsData();
  }, []);

  return (
    buyer.length > 0 && (
      <div className="border border-3 mb-5  wow fadeInUp p-4">
        <div className="row mb-2 d-flex  align-items-center justify-content-start  text-start">
          <div className="col-sm-5 col-md-4 ">
            <h6>Order ID:</h6>
            <p id="orderId">{id}</p>
          </div>
          <div className="col-sm-3 col-md-4">
            <h6>Order Status:</h6>
            <p id="status">{status}</p>
          </div>
          <div className="col-4">
            <h6>Order Date:</h6>
            <p id="date">{date}</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <h6 className="text-start">{`Buyer: ${buyer[0].firstname} ${buyer[0].lastname}`}</h6>
          </div>
        </div>
        <hr className="mb-4" />
        <div className="row">
          <div className="col-2 px-0">
            <h6 className="mb-0">Items: </h6>
          </div>
          <div id="item-detail-div" className="col-sm-10 px-0">
            <ul className="ps-0 mb-0">
              {productsData.length &&
                productsData.map((product) => (
                  <li>
                    <div className="row text-start">
                      <div className="col-sm-4 col-md-6 px-0">
                        <p id="item">
                          {/* {product._id} x{" "} */}
                          {product.name} x{" "}
                          {
                            items.find((item) => item.productId === product._id)
                              .quantity
                          }
                        </p>
                      </div>
                      <div className="col-3 px-0">
                        <p id="unit-price">Unit Price $ {product.price}</p>
                      </div>
                      <div className="col-sm-4 col-md-3 px-0">
                        <p id="total-price">
                          Total Price ${" "}
                          {product.price *
                            items
                              .find((item) => item.productId === product._id)
                              .quantity.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <hr className="mb-4" />
        <div className="row">
          <div className="col-2 px-0">
            <h6>Total: </h6>
          </div>
          <div className="col px-0 ">
            <h6 className="mb-0">$ {total.toFixed(2)}</h6>
          </div>
        </div>
      </div>
    )
  );
}

export default OrderCard;
